import { useState, useEffect, useRef } from 'react';
import { fetchConfig, getSelfieCamFromEvent } from './api';
import { displayErrorModal } from '../../helpers/swal';

// eslint-disable-next-line import/prefer-default-export
export const useSelfieCamConfig = (event) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const lastSlugDateRef = useRef(null);

  useEffect(() => {
    const slugDate = event?.slugDate ?? null;
    if (slugDate == null) return () => {};
    if (lastSlugDateRef.current === slugDate) return () => {};
    lastSlugDateRef.current = slugDate;

    const sc = getSelfieCamFromEvent(event);
    if (sc && (sc.language || sc.colors)) {
      setConfig(null);
      return () => {};
    }

    let cancelled = false;
    setLoading(true);
    fetchConfig()
      .then((data) => {
        if (!cancelled) setConfig(data);
      })
      .catch(() => {
        if (!cancelled) displayErrorModal({ text: 'Failed to load config.' });
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [event?.slugDate, event?._id]);

  return { config, loading };
};
